import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import ForceChangePasswordDialog from './ForceChangePasswordDialog';

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/" replace />;
  return (
    <>
      {children}
      {user.mustChangePassword && <ForceChangePasswordDialog />}
    </>
  );
}
